import React from 'react'
import Template from '../template/Template'
import tic from '../../../media/tic-tac-toe';
import primeChecker from '../../../media/primeChecker';
import wordConter from '../../../media/wordConter';
import dic from '../../../media/zDict.png'
import Calculator from '../../../media/Calculator.png'
import Youtube from '../../../media/youtube.png';
import chatBot from '../../../media/chatBot.webp';
// import ProjectTemplate from '../ProjectTemplate/ProjectTemplate'
export default function Js(props) {
    const Css = {
        "--background": `${props.isValue ? props.mode : 'red'}`
    }
    return (
        <>
            <div className="bodyCon projectCon">
                <div className="bodyComponent">
                    <div className="aboutHeading projectHeading " style={Css}>
                        <h1>JavaScript</h1>
                        <div className="container">
                            <div className="projects">
                                <a href='https://zer-0ne.github.io/Tic-Tac-toe' target='_blank' rel="noreferrer">
                                    <Template img={tic} />
                                </a>
                                <a href="https://zer-0ne.github.io/PrimeChecker/" target='_blank' rel="noreferrer">
                                    <Template img={primeChecker} />
                                </a>
                                <a href='https://zer-0ne.github.io/Word-Counter/' target='_blank' rel="noreferrer">
                                    <Template img={wordConter} />
                                </a>
                                <a href='https://zer-0ne.github.io/zDictionary' target='_blank' rel="noreferrer">
                                    <Template img={dic} />
                                </a>
                                <a href='https://zer-0ne.github.io/zCalculator' target='_blank' rel="noreferrer">
                                    <Template img={Calculator} />
                                </a>
                                <a href='https://zer-0ne.github.io/zYoutube' target='_blank' rel="noreferrer">
                                    <Template img={Youtube} />
                                </a>
                                <a href='https://zer-0ne.github.io/zChatBot' target='_blank' rel="noreferrer">
                                    <Template img={chatBot} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
